const getIsoDate = (date: string | number | Date) => {
  return new Date(date).toISOString().split("T")[0];
};

export { getIsoDate };
